export default "__VITE_ASSET__GRzTB$oN__"